<template>
  <div id="app">
    <div class="preloader" v-if="loading">
      <b-spinner variant="primary" label="Loading..." class="align-self-center"></b-spinner>
    </div>
    <component :is="layout" class="page" mode="in-out">
      <transition name appear>
        <router-view />
      </transition>
    </component>
  </div>
</template>

<script>
import Loading from "@/components/Loading";

export default {
  name: "App",
  components: {
    Loading
  },
  data() {
    return {
      transitionName: "slide-fade"
    };
  },
  beforeCreate() {
    if (this.$store.getters["auth/isAuthenticated"]) {
      this.$store
        .dispatch("auth/getUser")
        .then(res => {})
        .catch(err => {
          console.log(err);
        });
    }
  },
  watch: {
    // $route(to, from) {
    //   const toDepth = to.path.split("/").length;
    //   const fromDepth = from.path.split("/").length;
    //   this.transitionName = toDepth < fromDepth ? "slide-right" : "slide-left";
    // }
  },
  computed: {
    loading() {
      return false;
    },
    layout() {
      return (this.$route.meta.layout || "default") + "-layout";
    }
  }
};
</script>

<style lang="scss">
$body-bg: #fff;
$body-color: #272727;
$link-hover-color: rgb(18, 105, 177);
$theme-colors: (
  "primary": #5231a0,
  "dark": #38393a,
  "info": #2b9bcf
);

/* set the overriding variables */
$grid-breakpoints: (
  xs: 0,
  sm: 576px,
  md: 768px,
  lg: 992px,
  xl: 1200px,
  xxl: 1400px,
  xxxl: 1720px
);
$container-max-widths: (
  sm: 540px,
  md: 720px,
  lg: 960px,
  xl: 1140px,
  xxl: 1320px,
  xxxl: 1600px
);
// Bootstrap and its default variables
@import "node_modules/bootstrap/scss/bootstrap";
@import "node_modules/bootstrap-vue/src/index.scss";

h1,
.h1 {
  color: theme-color("primary");
  background: linear-gradient(to right, #472f91 0%, #9a4e8a 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 700;
}

h2,
.h2,
h3,
.h3 {
  color: theme-color("primary");;
  font-weight: 700;
}
h1,
.h1 {
  font-size: 2.2rem;
}
h3,
.h3 {
  font-weight: 600;
}

body {
  position: relative;
}

blockquote {
  margin-bottom: 1rem;
  border-left: solid 3px #d7d7d7;
  font-style: italic;
  padding: 0px 15px 0px 20px;
  margin: 1rem;
}

.preloader {
  position: fixed;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  z-index: 9999;
  text-align: center;
  background: rgba(255, 255, 255, 0.7);
}

.loader {
  display: flex;
  justify-content: center;
  width: 100%;
  text-align: center;
}

.page-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: #e3e3e3;
}

.slot-holder {
  position: relative;
}

.nav-toc {
  display: block;
}

.nav-toc-item {
  display: block;
  padding: 3px 0px;
}

.media-heading {
  font-size: 1.075rem;
  font-weight: bold;
}

/* slide fade */
.slide-fade-enter-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
  transition-delay: 0.1s;
}

.slide-fade-leave-active {
  transform: translateY(5px);
  opacity: 0.5;
}

.slide-fade-enter {
  transform: translateY(5px);
  opacity: 0;
}

/* slide left-right */
.slide-left-enter-active,
.slide-right-enter-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
  transition-delay: 0.3s;
}

.slide-left-enter,
.slide-right-leave-active {
  transform: translateY(5px);
  opacity: 0;
}

.slide-left-leave-active,
.slide-right-enter {
  transform: translateY(5px);
  opacity: 0;
}

/* slide page */
.page-enter-active,
.page-leave-active {
  transition: all 0.4s ease;
  opacity: 0;
}

.page-enter {
  transition: opacity 0.4s;
  transition-delay: 0.1s;
  opacity: 0;
}

.bounce-enter-active {
  animation: bounce-in 0.5s;
  animation-delay: 0.3s;
  opacity: 0;
}

.bounce-leave-active {
  animation: bounce-out 0.3s;
}

@keyframes bounce-in {
  0% {
    transform: scale(0.9);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes bounce-out {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scaleX(0.93);
    opacity: 0;
  }
}
</style>